// Scene category vocabulary + icon mapping — mirrors the mobile app's
// scene.categories.ts so a scene's category IS its visual identity (icon +
// gradient) in both apps. The category drives the icon, not scene.type.
import { Sun, Moon, Film, Music, Lock, Home, Briefcase, Coffee, Heart, Star } from 'lucide-react';

export const SCENE_CATEGORIES = [
  'General',
  'Morning',
  'Evening',
  'Movie',
  'Party',
  'Sleep',
  'Away',
  'Welcome',
  'Work',
  'Dinner',
  'Relax',
];

const CATEGORY_ICONS = {
  morning: Sun,
  evening: Moon,
  movie: Film,
  party: Music,
  sleep: Moon,
  away: Lock,
  welcome: Home,
  work: Briefcase,
  dinner: Coffee,
  relax: Heart,
  general: Star,
};

/** Icon component for a category; tolerates unknown/custom categories. */
export function iconForCategory(category) {
  return CATEGORY_ICONS[(category || '').toLowerCase()] || Star;
}
